import { Tabs, Modal } from 'antd'

import play from '../../assets/images/about/play.png'

import Introduction from './Introduction';
// import Path from './Path';
import Strategy from './Strategy';
import Culture from './Culture';
import Honor from './Honor';
import Contract from './Contract';

import styles from './index.module.scss'
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router'
import { urlParams } from 'utils/urlParams';

const aboutList = [
    {
        index: 0,
        label: '公司简介',
        content: Introduction
    },
    // {
    //     index: 1,
    //     label: '发展历程',
    //     content: Path
    // },
    {
        index: 2,
        label: '发展战略',
        content: Strategy
    },
    {
        index: 3,
        label: '企业文化',
        content: Culture
    },
    {
        index: 4,
        label: '资质荣誉',
        content: Honor
    },
    {
        index: 5,
        label: '联系我们',
        content: Contract
    }
];

const videoSrc = `${window.location.origin}/files/fhxk.mp4`;

function About() {

    const [activeKey, setActiveKey] = useState('1');
    const [isFixed, setIsFixed] = useState(false);
    const [showVideo, setShowVideo] = useState(false);

    const location = useLocation();

    useEffect(() => {
        // 获取当前路由是否有指定跳转tab
        if (location.search) {
            urlParams.getUrlParams('tab') === 'DevelopmentPath' && setActiveKey('2');
            urlParams.getUrlParams('tab') === 'Honor' && setActiveKey('5');
        }

        // 监听页面滚动
        document.addEventListener('scroll', onScroll);

        return () => document.removeEventListener('scroll', onScroll);
    }, []);

    const onScroll = (e) => {
        // 距顶部
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        // 超过400 tab置顶于nav下面
        if (scrollTop > 400) {
            setIsFixed(true);
        } else {
            setIsFixed(false);
        }
    }

    useEffect(() => {
        if (activeKey === '6') {
            document.getElementsByClassName('ant-tabs-content-holder')[0].classList.add('contract');
        } else {
            document.getElementsByClassName('ant-tabs-content-holder')[0].classList.remove('contract');
        }
    }, [activeKey]);

    const onTabClick = (key) => {
        if (key !== activeKey) {
            setActiveKey(key);
            // 判断当前tab是否被固定
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            setTimeout(() => {
                document.documentElement.scrollTo(0, scrollTop > 400 ? 400 : scrollTop);
            }, 30);
        }
    }

    return (
        <>
            <div  className={styles['about-wrapper']}>
                <div  className={styles['banner']}>
                    <div  className={styles['title']}>关于星空</div>
                    <div  className={styles['content']}>广泛服务于公安、政务、海关等各个重要行业领域</div>
                    <div
                         className={styles['see-detail']}
                        onClick={() => {
                            setShowVideo(true);
                        }}
                    >
                        <img src={play} alt="" /> 企业宣传片
                    </div>
                </div>
                <div className={`${styles['about-container']} ${isFixed ? styles['fixed-tabs'] : ''}`}>
                    <Tabs
                        defaultActiveKey='1'
                        activeKey={activeKey}
                        onTabClick={onTabClick}
                        centered
                        destroyInactiveTabPane
                        items={aboutList.map((item) => ({
                            label: item.label,
                            key: String(item.index + 1),
                            children: item.content()
                        }))} />
                </div>
            </div>
            <Modal
                wrapClassName='video-wrapper'
                maskStyle={{
                    backgroundColor: 'rgba(0,0,0,0.8)'
                }}
                style={{
                    width: '960px',
                    height: '540px'
                }}
                centered
                destroyOnClose
                maskClosable={false}
                footer={null}
                open={showVideo}
                onCancel={() => {
                    setShowVideo(false)
                }}
            >
                <video id="fhxkVideo" controls preload="auto" data-setup="{}" controlsList='nodownload' autoPlay>
                    <source src={videoSrc} type="video/mp4" />
                </video>
            </Modal>
        </>

    )
}

export default About